export * from './full-layout.component';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/containers/full-layout/index.ts